/**
 * @file product.ts
 * @description Заготовки группы «Страница товара» (phase19.16 Р2а; решение
 * пользователя 2026-10-12: три раскладки страницы товара как заготовки;
 * uiux-design-r2a §3). Видны только в шаблоне страницы товара (контекст
 * productTemplate): в них элементы данных товара.
 *
 * Раскладка — несколько блоков (`buildLayout`), её применение заменяет блоки
 * черновика шаблона; `build()` — главный блок раскладки (с «Ценой и
 * покупкой») для превью. Источник раскладок — `PRODUCT_TEMPLATE_LAYOUTS`.
 */

import { PRODUCT_TEMPLATE_LAYOUTS, type ProductTemplateLayout } from "../product-template.js";
import type { SectionPayload } from "../schema.js";
import type { SectionPreset } from "./types.js";

/** Главный блок раскладки — тот, где стоит «Цена и покупка». */
function mainSection(sections: SectionPayload[]): SectionPayload {
  const main = sections.find((s) => s.columns.items.some((c) => c.elements.some((e) => e.kind === "product-buy")));
  return main ?? sections[0]!;
}

function layoutPreset(layout: ProductTemplateLayout): SectionPreset {
  return {
    key: layout.key,
    group: "product",
    title: layout.title,
    hint: layout.hint,
    previewKey: layout.key,
    backgroundPhoto: false,
    requires: null,
    contexts: ["productTemplate"],
    build: () => mainSection(layout.build()),
    buildLayout: () => layout.build(),
  };
}

export const SECTION_PRESETS_PRODUCT: readonly SectionPreset[] = PRODUCT_TEMPLATE_LAYOUTS.map(layoutPreset);
